import { TransactionProvider } from '@principle-theorem/principle-core/interfaces';
import { Region } from '@principle-theorem/shared';
import { of } from 'rxjs';
import {
  TransactionProviderType,
  type IResolvedTransactionOption,
  type ITransactionProvider,
} from './transaction-provider';

export function MockResolvedTransactionOption(
  provider: Partial<ITransactionProvider> = {}
): IResolvedTransactionOption {
  return {
    label: 'Cash',
    icon: 'payments',
    provider: {
      providerId: TransactionProvider.Cash,
      providerType: TransactionProviderType.Payment,
      providerRegions: [Region.Australia],
      isEnabled$: of(true),
      canCapture$: () => of(true),
      capture: () => Promise.resolve(undefined),
      ...provider,
    },
  };
}
